export const privacyStatementComponent = {
  template: `
    <div xw-popup display="vm.display" id="privacy-statement-popup" close-button title="{{ 'PRIVACY_STATEMENT' | translate }}" on-close="vm.onClose()">
      <privacy-statement-en ng-if="vm.privacyStatementLanguageService.isDefault()"></privacy-statement-en>
      <privacy-statement-ca ng-if="vm.privacyStatementLanguageService.isCurrent('ca')"></privacy-statement-ca>
      <privacy-statement-cs ng-if="vm.privacyStatementLanguageService.isCurrent('cs')"></privacy-statement-cs>
      <privacy-statement-es ng-if="vm.privacyStatementLanguageService.isCurrent('es')"></privacy-statement-es>
    </div>
    `,
  controllerAs: "vm",
  controller: class privacyStatementCtrl {
    /* @ngInject*/
    constructor(appSettings, privacyStatementLanguageService, commonService) {
      this.appSettings = appSettings;
      this.privacyStatementLanguageService = privacyStatementLanguageService;
      this.commonService = commonService;
    }

    $onInit() {
      this.display = true;
    }

    onClose() {
      this.onOk();
    }
  },
  bindings: {
    onOk: "&",
  },
};



// WEBPACK FOOTER //
// ./src/app/components/privacyStatement.component.js